export const MAX_COLUMNS_NUMBER_TABLE_PREVIEW = 200

export type FieldSchema = {
  name: string
  type: string
  tooltip?: string
}

export const ROWS_PER_PAGE_OPTIONS = [10, 30, 50, 100, 200]
